import LabeledVertical from '../../../components/raExtend/labels/LabeledVertical';
import { DateField, TextField } from 'react-admin';
import { RecordContextProvider, useTranslate } from 'ra-core';
import { Negotiation } from '../types';
import ContentWrapper from '../offerDrawer/ContentWrapper';
import MoneyField from '../../../components/raExtend/fields/MoneyField';
import { DEFAULT_DATE_FIELD_OPTIONS } from '../../../constants';

function NegotiationCard({ negotiation }: { negotiation: Negotiation }) {
  const t = useTranslate();

  return (
    <RecordContextProvider value={negotiation}>
      <ContentWrapper>
        <div className="grid grid-cols-3 gap-6 w-full">
          <LabeledVertical label="By">
            <TextField<Negotiation>
              source="user.name"
              emptyText={negotiation?.user?.id}
            />
          </LabeledVertical>
          <LabeledVertical label="Submitted">
            <DateField<Negotiation>
              source="created_at"
              options={DEFAULT_DATE_FIELD_OPTIONS}
            />
          </LabeledVertical>
          <LabeledVertical label="Action">
            {negotiation.action_type && (
              <p className="text-sm text-muted-foreground">
                {t(`offer.negotiation.action.${negotiation.action_type}`, {
                  _: negotiation.action_type,
                })}
              </p>
            )}
          </LabeledVertical>
          <LabeledVertical label="Total budget">
            <MoneyField<Negotiation> source="budget_total" />
          </LabeledVertical>
          <LabeledVertical label="Pricing model">
            <p className="text-muted-foreground text-sm">
              {t(`offer.pricing_model.${negotiation.pricing_model}`, {
                _: t('common.text.unavailable'),
              })}
            </p>
          </LabeledVertical>
          {negotiation.rate > 0 && (
            <LabeledVertical label="Rate">
              <MoneyField<Negotiation> source="rate" />
            </LabeledVertical>
          )}
          <LabeledVertical label="Note">
            <TextField<Negotiation> source="action_note" emptyText="-" />
          </LabeledVertical>
        </div>
      </ContentWrapper>
    </RecordContextProvider>
  );
}

export default NegotiationCard;
